"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styler = exports.modify = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

/**
 * Flattens the provided (nestable) arguments, parsing strings, numbers,
 * arrays, and truthy-valued objects into an array of strings
 * Adapted from JedWatson/classnames
 * @param {...*} strings - String or strings
 * @returns {Array.<string>} - A flattened array of strings
 */
// eslint-disable-next-line complexity
var flatten = function flatten() {
  var _arguments = arguments;
  var values = [];

  var _loop = function _loop(i) {
    var arg = i < 0 || _arguments.length <= i ? undefined : _arguments[i];

    if (arg) {
      var argType = _typeof(arg);

      if (argType === 'string') {
        values.push.apply(values, _toConsumableArray(arg.split(' ')));
      } else if (argType === 'number') {
        values.push(arg.toString());
      } else if (Array.isArray(arg)) {
        if (arg.length) {
          var inner = flatten.apply(void 0, _toConsumableArray(arg));
          values.push.apply(values, _toConsumableArray(inner));
        }
      } else if (argType === 'object') {
        if (arg.toString === Object.prototype.toString) {
          Object.keys(arg).forEach(function (key) {
            if ({}.hasOwnProperty.call(arg, key) && arg[key]) {
              values.push(key);
            }
          });
        } else {
          values.push(arg.toString());
        }
      }
    }
  };

  for (var i = 0; i < arguments.length; i++) {
    _loop(i);
  }

  return values;
};
/**
 * Apply BEM modifiers to the provided classes,
 * omitting pre-modified classes and returning a
 * valid className string
 * @param {*} classes - Classes
 * @param {...*} modifiers - Modifiers
 * @returns {Array.<string>} - A string of class names
 */


var modify = function modify(classes) {
  var classesFlat = flatten(classes);

  for (var _len = arguments.length, modifiers = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    modifiers[_key - 1] = arguments[_key];
  }

  var modifiersFlat = flatten(modifiers);
  var hasModifiers = modifiersFlat.length;
  var classNames = classesFlat.reduce(function (result, unmodifiedClass) {
    var modifiedClass = unmodifiedClass;

    if (hasModifiers && !unmodifiedClass.match(/--/)) {
      var modified = modifiersFlat.map(function (modifier) {
        return "".concat(unmodifiedClass, "--").concat(modifier);
      }).join(' ');
      modifiedClass = "".concat(unmodifiedClass, " ").concat(modified);
    }

    result.push(modifiedClass);
    return result;
  }, []);
  return classNames.join(' ');
};
/**
 * Generate a function with modifiers pre-defined
 * @param {...*} modifiers - Modifiers
 * @returns {Func} - A modify() wrapper with modifiers pre-defined
 */


exports.modify = modify;

var styler = function styler() {
  for (var _len2 = arguments.length, modifiers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    modifiers[_key2] = arguments[_key2];
  }

  return function (className) {
    return modify.apply(void 0, [className].concat(modifiers));
  };
};

exports.styler = styler;